import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { selectAtom } from 'jotai/utils'

import { authTokenAtom } from '../atoms/auth-token.atom'

export const useAuthTokenValue = () => {
    const token = useAtomValue(useMemo(() => selectAtom(authTokenAtom, (auth) => auth), []))

    return {
        token,
    }
}

export const useAuthIsAuthenticated = () => {
    const isAuthenticated = useAtomValue(useMemo(() => selectAtom(authTokenAtom, Boolean), []))

    return {
        isAuthenticated,
    }
}
